import moment from 'moment'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueSegmentAnalytics from 'vue-segment-analytics'
import Vue2Filters from 'vue2-filters'
import smoothScrollPolyfill from 'smoothscroll-polyfill'
import Meta from 'vue-meta'
import VueClipboards from 'vue-clipboards'
import 'nodelist-foreach-polyfill'

import 'filters/moment'
import 'filters/eventDate'
import 'filters/percent'
import 'filters/roundNumber'
import 'filters/venueCurrency'
import 'filters/capitalize'

import config from 'src/config'
import 'lib/stripe'

//vue modals
import VueModals from 'components/VueModals'
import vueModalService from 'lib/vueModals'

//COMPONENTS
import App from 'pages/App'
import Loading from 'components/Loading'
import Checkbox from 'components/Checkbox'
import PoweredBy from 'components/PoweredBy'
import BtnSpinner from 'components/BtnSpinner'
import Modal from 'components/Modal'
import StripeCard from 'components/StripeCard'
import StripePaymentRequestButton from 'components/StripePaymentRequestButton'
import TimePicker from 'components/TimePicker'
import BirthdayPicker from 'components/BirthdayPicker'
import TelInput from 'components/TelInput'
import BirthdayInput from 'components/BirthdayInput'
// import DateInput from 'components/DateInput';
import Dropdown from 'components/Dropdown'
import CheckoutComplete from 'components/CheckoutComplete'
import CheckoutItems from 'components/CheckoutItems'
import PaymentProfile from 'components/PaymentProfile'
import AppleWalletButton from 'components/AppleWalletButton'
import ApplePayIcon from 'components/ApplePayIcon'
import WebPayIcon from 'components/WebPayIcon'
import Radio from 'components/Radio'
import ReadMore from 'components/ReadMore'
import FormControl from 'components/FormControl'
import CheckoutVenueInfo from 'components/CheckoutVenueInfo'
import CheckoutSummary from 'components/CheckoutSummary'
import TopBarNotifications from 'components/TopBarNotifications'
import MiniToasts from 'components/MiniToasts'
import Signature from 'components/Signature'
import CannabisTypeLabel from 'components/CannabisTypeLabel'
import ItemCard from 'components/ItemCard'
import SelectQuantity from 'components/SelectQuantity'
import SelectPickUpTime from 'components/SelectPickUpTime'
import SearchInput from 'components/SearchInput'
import GliderCarousel from 'components/GliderCarousel'
import CustomerChat from 'components/CustomerChat'
import ChatHeader from 'components/ChatHeader'
import Pagination from 'components/Pagination'
//ORDERS
import OrderCart from 'components/OrderCart'
import OrderSidebar from 'components/OrderSidebar'

//DIRECTIVES
import load from 'directives/load'
import imgSrc from 'directives/imgSrc'

import router from 'src/router'
import store from 'src/store'

import './styles/main.less'

smoothScrollPolyfill.polyfill()

Vue.config.productionTip = false
Vue.config.devtools = false

Vue.use(VeeValidate)
Vue.use(VueSegmentAnalytics, {
  id: config.SEGMENT_ANALYTICS,
  router,
})
Vue.use(Vue2Filters)
Vue.use(Meta)
Vue.use(VueClipboards)
Vue.use({
  install: function (NewVue) {
    Vue.component('vue-modals', VueModals)
    NewVue.prototype.$showModal = vueModalService.showModal
  },
})

Vue.component('loading', Loading)
Vue.component('checkbox', Checkbox)
Vue.component('powered-by', PoweredBy)
Vue.component('btn-spinner', BtnSpinner)
Vue.component('modal', Modal)
Vue.component('stripe-card', StripeCard)
Vue.component('stripe-payment-request-button', StripePaymentRequestButton)
Vue.component('time-picker', TimePicker)
Vue.component('birthday-picker', BirthdayPicker)
Vue.component('tel-input', TelInput)
Vue.component('birthday-input', BirthdayInput)
// Vue.component('date-input', DateInput);
Vue.component('dropdown', Dropdown)
Vue.component('checkout-complete', CheckoutComplete)
Vue.component('checkout-items', CheckoutItems)
Vue.component('payment-profile', PaymentProfile)
Vue.component('apple-wallet-button', AppleWalletButton)
Vue.component('apple-pay-icon', ApplePayIcon)
Vue.component('web-pay-icon', WebPayIcon)
Vue.component('radio', Radio)
Vue.component('read-more', ReadMore)
Vue.component('form-control', FormControl)
Vue.component('checkout-venue-info', CheckoutVenueInfo)
Vue.component('checkout-summary', CheckoutSummary)
Vue.component('top-bar-notifications', TopBarNotifications)
Vue.component('mini-toasts', MiniToasts)
Vue.component('signature', Signature)
Vue.component('cannabis-type-label', CannabisTypeLabel)
Vue.component('item-card', ItemCard)
Vue.component('select-quantity', SelectQuantity)
Vue.component('select-pick-up-time', SelectPickUpTime)
Vue.component('search-input', SearchInput)
Vue.component('glider-carousel', GliderCarousel)
Vue.component('customer-chat', CustomerChat)
Vue.component('chat-header', ChatHeader)
Vue.component('pagination', Pagination)

//ORDERS
Vue.component('order-cart', OrderCart)
Vue.component('order-sidebar', OrderSidebar)

Vue.directive('load', load)
Vue.directive('img-src', imgSrc)

VeeValidate.Validator.extend('minAge', {
  getMessage: (field) => `The ${field} value is not truthy.`,
  validate: (value, minAge) => {
    if (!value || !value.length) return true

    const birthday = moment.utc(value, 'MM/DD/YYYY')

    const now = moment.utc()

    if (birthday.isAfter(now)) return false

    const ageDifMs = Date.now() - birthday.toDate().getTime()
    const ageDate = new Date(ageDifMs) // miliseconds from epoch

    const age = Math.abs(ageDate.getUTCFullYear() - 1970)

    return age >= minAge
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App></App>',
  components: {
    App,
  },
})



// WEBPACK FOOTER //
// ./src/main.js